import { IWorkflowNode } from "motw_core/Entity/IWorkflowNode";
import { EFontFamily } from "motw_core/Enums/EFontFamily";
import { GetWorkflowNodeFontStyle } from "../GetWorkflowNodeFontStyle";

export function GetFontSize(rootNode: IWorkflowNode) {
    const fontStyle = GetWorkflowNodeFontStyle(rootNode);
    const fontFamily = fontStyle.fontFamily;

    if (!fontFamily) {
        return ``;
    }

    if (fontFamily === EFontFamily[EFontFamily["Open Sans"]]) {
        return `16px`;
    }

    return ``;
}
